<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<div class="sf-col sf-col-12">
				<sf-card class="p-0 h-100 card_bg">
					<pc-ro-list-search
						ref="search"
						@OpenOpPopup="OpenOpPopup"
						:scrId="scrId"
						:pStartDt="pStartDt"
						:pEndDt="pEndDt"
						:pStartDt2="pStartDt2"
						:pEndDt2="pEndDt2"
						:pState1="pState1"
						:pState2="pState2"
						:pState3="pState3"
						:pState4="pState4"
						:pState5="pState5"
						:pState6="pState6"
						:pState7="pState7"
						:pState8="pState8"
						:pState9="pState9"
						:pState10="pState10"
						:pState11="pState11"
						:pState12="pState12"
						:pState13="pState13"
						:pState14="pState14"
						:pState15="pState15"
						:pState16="pState16"
						:pState17="pState17"
						:pState18="pState18"
					></pc-ro-list-search>
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-ro-list-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-ro-list-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 끝 -->

			<com-cd-popup ref="comCdPopup" @SendData="sendData2" @Refresh="Refresh" :scrId="scrId"></com-cd-popup>
		</div>
	</div>
</template>

<script>
import PcRoListSearch from './Search/PcRoListSearch.vue';
import PcRoListTable from './Table/PcRoListTable.vue';
import ComCdPopup from '@/views/qms/comm/commpopup/ComCdPopup/ComCdPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //판매 시작월
		pEndDt: { type: String, default: '' }, //판매 종료월
		pStartDt2: { type: String, default: '' }, //조건 시작월
		pEndDt2: { type: String, default: '' }, //조건 종료월
		pState1: { type: String, default: '' }, //부품유형
		pState2: { type: String, default: '' }, //차량구분
		pState3: { type: String, default: '' }, //승상구분
		pState4: { type: String, default: '' }, //연료전지사양
		pState5: { type: String, default: '' }, //판매지역
		pState6: { type: String, default: '' }, //사용기간(1m,2m,3m,12m,WM)
		pState7: { type: String, default: '' }, //RO처리단계
		pState8: { type: String, default: '' }, //RO처리결과
		pState9: { type: String, default: '' }, //Ctype
		pState10: { type: String, default: '' }, //차종유형
		pState11: { type: String, default: '' }, //판매월검색조건 HTWO판매월
		pState12: { type: String, default: '' }, //검색조건 조건월
		pState13: { type: String, default: '' }, //검색조건 사용기간(년)
		pState14: { type: String, default: '' }, //지수구분
		pState15: { type: String, default: '' }, //현상코드
		pState16: { type: String, default: '' }, //누적
		pState17: { type: String, default: '' }, //품번
		pState18: { type: String, default: '' } //정비유형
	},
	data() {
		return {};
	},
	created() {
		//console.clear();
	},
	components: { PcRoListSearch, PcRoListTable, ComCdPopup },
	methods: {
		Refresh() {
			this.$refs.search.searchList();
		},
		OpenOpPopup(commCd) {
			this.$refs.comCdPopup.open(commCd); //.open(param);
		},
		sendData2(param) {
			//this.setSearchParam_({ key: 'opCd', value: param.commCd });
			this.$refs.search.setSearchParam({ key: 'opCd', value: param.commCd });
			this.$refs.search.setSearchParam({ key: 'opCdNm', value: param.commCdName });
		}
	}
};
</script>

<style></style>
